/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: 0,
    categoryName: "Jersey",
  },
  {
    _id: 1,
    categoryName: "Shorts",
  },
  {
    _id: 2,
    categoryName: "Football",
  },
];
